import { render, staticRenderFns } from "./CategoryTreeSelect.vue?vue&type=template&id=4948759f&"
import script from "./CategoryTreeSelect.vue?vue&type=script&lang=js&"
export * from "./CategoryTreeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports